<template>
    <div class="automation-action-settings">
        <p>{{ t('automations-form-actions-add_to_segment-description') }}</p>
        <div class="field">
            <div v-if="segments.length > 0">
                <label
                    :class="{
                        label: true,
                        'label-danger': !segmentId,
                    }"
                >{{ t('automations-form-actions-segment_membership-segment_label') }}</label>
                <select v-model="segmentId" class="form-control">
                    <option value="">{{ t('automations-form-actions-segment_membership-segment_placeholder') }}</option>
                    <option
                        v-for="segment in segments"
                        :key="segment.id"
                        :value="segment.id"
                    >
                        {{ segment.name }}
                    </option>
                </select>
            </div>
            <div v-else>
                <span class="far fa-spinner fa-spin" />
                {{ t('automations-form-actions-segment_membership-loading_segments') }}
            </div>
        </div>
    </div>
</template>

<script>
import keviApi from "../../../keviApi";

export default {
    props: {
        properties: Object,
    },
    data: function () {
        return {
            title: this.t("automations-form-actions-add_to_segment-title"),
            description: this.t("automations-form-actions-add_to_segment-description"),
            segmentId: this.properties.segmentId || "",
            segments: [],
        };
    },
    mounted: function () {
        let options = keviApi.getOptions("segments");
        this.$http(options).then((response) => {
            this.segments = response.body.filter((segment) => segment.type === "manual");
            window.setTimeout(() => {
                this.changed();
            }, 100);
        });
        this.$emit("mounted", this);
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        isValid() {
            return this.segmentId !== "";
        },
        changed: function () {
            this.$emit("propertiesUpdated", {
                segmentId: this.segmentId,
            });
        },
    },
    watch: {
        segmentId: function () {
            this.changed();
        },
    },
};
</script>
